/** @format **/
import React, { FunctionComponent, ReactElement } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { MnoMessageInterface } from '../../interfaces/collections/MnoMessageInterface';
import CardHeader from '../../components/Card/CardHeader';
import { DateHelper } from '../../helpers/DateHelper';
import CardBody from '../../components/Card/CardBody';
import XmlView from '../Provisioning/components/XmlView';
import Card from '@material-ui/core/Card';
import GridContainer from '../../components/Grid/GridContainer';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';

type MnoMessageViewType = {
    openView: boolean;
    fullWidth: boolean;
    title: string | null;
    closeCallback(): void;
    mnoMessage: MnoMessageInterface | null;
};

export const MnoMessageView: FunctionComponent<MnoMessageViewType> = ({ openView, fullWidth, title, closeCallback, mnoMessage }): ReactElement => {
    return (
        <Dialog
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            keepMounted
            open={openView}
            fullWidth={fullWidth}
            maxWidth="lg"
        >
            <DialogTitle>
                <GridContainer justifyContent={'space-between'}>
                    <h4>
                        {title === null && ''}
                        {typeof title === 'string' ? <I18n trans={title} /> : title}
                    </h4>
                    <Button onClick={closeCallback} color="primary">
                        <Cancel width={24} height={24} />
                    </Button>
                </GridContainer>
            </DialogTitle>
            {mnoMessage && (
                <DialogContent>
                    <Card>
                        <CardHeader>
                            <Typography variant="subtitle2">
                                <I18n trans="prov:api.api_plk_request_wc" valueObject={{ time: DateHelper.format(mnoMessage?.createdAt) }} />
                            </Typography>
                        </CardHeader>
                        <CardBody>{mnoMessage.notifyRequest.length > 0 && XmlView(mnoMessage?.notifyRequest)}</CardBody>
                        <CardHeader>
                            <Typography variant="subtitle2">
                                <I18n trans="prov:api.api_plk_response" valueObject={{ time: DateHelper.format(mnoMessage?.processedTime) }} />
                            </Typography>
                        </CardHeader>
                        <CardBody>{mnoMessage.notifyResponse.length > 0 && XmlView(mnoMessage?.notifyResponse)}</CardBody>
                    </Card>
                </DialogContent>
            )}
        </Dialog>
    );
};
